import Header from './components/Header';
import Hero from './components/Hero';
import SectionFAQ from './components/SectionFAQ';
import SectionMedia from './components/SectionMedia';
import SectionAbout from './components/SectionAbout';
import SectionRanking from './components/SectionRanking';
import SectionCards from './components/SectionCards';
import SectionContact from './components/SectionContact';
import SectionFeatures from './components/SectionFeatures';
import SectionTopics from './components/SectionTopics';
import SectionCarousel from './components/SectionCarousel';
import SectionUpdates from './components/SectionUpdates';
import SectionIndex from './components/SectionIndex';
import SectionApp from './components/SectionApp';
import SectionComments from './components/SectionComments';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionFAQ />
        <SectionMedia />
        <SectionAbout />
        <SectionRanking />
        <SectionCards />
        <SectionContact />
        <SectionFeatures />
        <SectionTopics />
        <SectionCarousel />
        <SectionUpdates />
        <SectionIndex />
        <SectionApp />
        <SectionComments />
      </main>
      <Footer />
    </>
  );
}